module.exports = __webpack_public_path__ + "static/media/kaiser.33b723b1.jpg";